import {Module} from 'vuex';
import {RootState} from '@/types';
import SponsorApi from '@/api/SponsorApi';
import {namespace} from 'vuex-class';
import {
  SET_SPONSOR,
  SET_SPONSORS,
  SET_PRODUCTSPONSOR,
} from '@/store/mutationTypes';

export const sponsorModule = namespace('sponsor');

export interface Sponsor {
  [key: string]: any;
}

interface SponsorState {
  sponsors: Sponsor[];
  sponsor: Sponsor | null;
  detailProductSponsor: Sponsor[];
}

export default <Module<SponsorState, RootState>>{
  namespaced: true,
  state: {
    sponsors: [],
    sponsor: null,
    detailProductSponsor: [],
  },
  mutations: {
    [SET_PRODUCTSPONSOR](state, data) {
      state.detailProductSponsor = data;
    },
    [SET_SPONSORS](state, data) {
      state.sponsors = data;
    },
    [SET_SPONSOR](state, data) {
      state.sponsor = data;
    },
  },
  actions: {
    async all({commit}, params = {}) {
      try {
        const {data} = await SponsorApi.all(params);
        if (!!params.paginate) {
          commit(SET_SPONSORS, data.data);
        } else {
          commit(SET_SPONSORS, data.data.data);
        }
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async detail({commit}, id) {
      try {
        const {data} = await SponsorApi.detail(id);
        commit(SET_SPONSOR, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async create(_, payload) {
      try {
        const {data} = await SponsorApi.create(payload);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async update(_, {id, payload}) {
      try {
        const {data} = await SponsorApi.update(id, payload);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async delete(_, id) {
      try {
        const {data} = await SponsorApi.delete(id);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async attachProduct(_, {id, payload}) {
      try {
        const {data} = await SponsorApi.attachProduct(id, payload);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async productSponsorDetail({commit}, {id, params = {}}) {
      try {
        const {data} = await SponsorApi.productSponsor(id, params);
        commit(SET_PRODUCTSPONSOR, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async AttctDelete(_, {id, payload}) {
      try {
        const {data} = await SponsorApi.attactDelete(id, payload);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
  },
  getters: {},
};
